import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import EnrollABHAviaAadhaar from '@custom/rtk-apis/abha/enrollViaAadhaar';

const initialState = {
    data: {},
    status: "",
    loading: false,
    error: "",
    message: "",
};

const EnrollABHAviaAadhaarSlice = createSlice({
    name: 'EnrollABHAviaAadhaarSlice',
    initialState,
    reducers: {
      clearState: state => {
        state.data = {};
        state.status = '';
        state.loading = false;
        state.error = '';
        state.message = '';
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(EnrollABHAviaAadhaar.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(EnrollABHAviaAadhaar.fulfilled, (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.status = action.payload.status;
          state.data = action.payload.data;
          state.message = action.payload.data.message;
        })
        .addCase(EnrollABHAviaAadhaar.rejected, (state, action: PayloadAction<any>) => {
          console.log("state.error", action.payload)
          state.loading = false;
          state.status = "FAILED";
          state.error = action.payload;
        });
    },
  });
  
export default EnrollABHAviaAadhaarSlice.reducer;
export const { clearState } = EnrollABHAviaAadhaarSlice.actions;
